/**
 * @module common/components/base_ui/help_drawer
 */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';

/**
 * Drawer component sliding from top with contact info
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const HelpDrawer = ({ desktop }) => {
  if (desktop) {
    return (
      <div className="help-drawer help-drawer-desktop">
        <p>
          Questions?{' '}
          <span className="tel-wrapper">
            <a className="tel" href="tel:+1.877.887.7442">+1.877.887.7442</a> or
          </span>{' '}
          <Link to="/help/contact/" target="_blank">Email us</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="help-drawer help-drawer-mobile">
      <div>Questions?</div>
      <div className="tel-wrapper"><a href="tel:+1.877.887.7442">+1.877.887.7442</a></div>
      <div><a href="/help/contact/" target="_blank">Email us</a></div>
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {boolean} desktop - boolean defining if we're rendering the drawer on desktop
 */
HelpDrawer.propTypes = {
  desktop: PropTypes.bool,
};

export default HelpDrawer;
